
const ViewBankAccountDetails = ({ bankData }) => {
  return (
    <>
      <div className="p-4 rounded shadow-sm mt-5 mb-3 position-relative" style={{ backgroundColor: bankData?.bgColor }}>
        <div
          className="rounded-circle bg-white position-absolute border hstack justify-content-center align-items-center start-50 translate-middle-x"
          style={{ top: -30, width: 50, height: 50 }}
        >
          <img width={25} height={25} src={bankData?.icon} />
        </div>
        <div className="text-center text-white mt-2">
          <h6>{bankData?.bankName}</h6>
        </div>
        <div className="d-flex justify-content-between mt-4 flex-end">
          <div className="text-white">
            <h6 style={{ fontSize: 10 }}>Account Number</h6>
            <h5 style={{ fontSize: 13 }} className="mt-2">
              4567 8901 2345 6789
            </h5>
            <h6 style={{ fontSize: 10 }} className="mt-4">Account Holder Name</h6>
            <h5 style={{ fontSize: 13 }}>
              Rahul Sharma
            </h5>
          </div>
          <div className="text-white">
            <h6 style={{ fontSize: 10 }}>IFSC</h6>
            <h5 style={{ fontSize: 13 }}>
              SBIN0001234
            </h5>
            <h6 style={{ fontSize: 10 }} className="mt-4">Account Type</h6>
            <h5 style={{ fontSize: 13 }}>Saving</h5>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewBankAccountDetails;
